<script lang="ts">
  import { goto } from "$app/navigation";
  import TopTeams from "$components/top-teams/index.svelte";
  import SearchComp from "$components/search/index.svelte";
  import SliderComp from "$components/slider/index.svelte";
  import FullBanner from "$components/full-banner/index.svelte";
  import PopularEvents from "$components/popular-events/index.svelte";
  import Upcominggames from "$components/upcoming-games/index.svelte";
  import TopTournaments from "$components/top-tournaments/index.svelte";
  import Trustpilot from "$components/trustpilot/horizontal.svelte";
  // import TrustpilotSmall from "$components/trustpilot/mini.svelte";
  import MetaComponent from "$components/meta/index.svelte";
  import { openModal } from "@thehood/svlib";
  import LoginModal from "$components/navbar/login/login-modal.svelte";
  import { onMount } from "svelte";
  import type { PageData } from "./$types";

  export let data: PageData;
  const {
    featured = [],
    popularEvents = [],
    upcominggames = [],
    topTeams = [],
    locale = "en",
    pageInfo,
    topTournaments,
    gotoLogIn,
  } = data;

  onMount(() => {
    if (gotoLogIn) {
      openModal(LoginModal);
    }
  });
</script>

<MetaComponent meta={pageInfo.meta} />

<div class="content-grid home-page">
  <div class="full-width hero-bg">
    <div class="slider-container">
      <div class="left-top grid">
        <div class="one-bg"></div>
        <div>
          <h2 class="search-header">Search & Book Football Tickets</h2>
          <p class="sf-300 search-header-text">
            Book your tickets on the number one football ticket platform. Secure the best seats at the best price.
          </p>
          <div>
            <SearchComp {locale} />
          </div>
        </div>
      </div>
      <div class="home-slider">
        <SliderComp {featured} />
      </div>
    </div>
  </div>
  <!--  -->
  {#if popularEvents.length}
    <div class="popular-tickets">
      <div class="popular-container">
        <h2 class="sf-700">Popular Football Events</h2>
        <PopularEvents data={popularEvents} {locale} />
      </div>
    </div>
  {/if}
  <!--  -->
  {#if upcominggames.length}
    <div class="full-width upcoming-bg">
      <div class="upcoming-games page-content">
        <h2 class="sf-700">Upcoming Games</h2>
        <div class="upcoming-games-inner grid">
          <Upcominggames {upcominggames} {locale} />
          <div class="upcoming-games-right">
            <FullBanner hideSecondary={false} vertical={true} className="bg-grey" theme="dark" none={true}>
              <!-- <div slot="vertical">
                <TrustpilotSmall theme="dark" />
              </div> -->
            </FullBanner>
          </div>
        </div>
      </div>
    </div>
  {/if}
  <!--  -->
  {#if topTeams.length}
    <div class="full-width top-tt">
      <div class="page-content grid top-tt-container">
        <h2 class="sf-700">Top Teams</h2>
        <hr class="hr mob-only" />
        <div class="tt-inner">
          <TopTeams {topTeams} {locale} />
        </div>
        <button class="tt-view-more sf-500" on:click={() => goto(`/teams`)}>All Teams</button>
      </div>
    </div>
  {/if}
  <!--  -->
  <div class="page content trustpilot-mobile">
    <Trustpilot />
  </div>

  {#if topTournaments.length}
    <div class="full-width top-tt tournaments-bg">
      <div class="page-content grid top-tt-container tournaments-bg-w">
        <h2 class="sf-700">Top Tournaments</h2>
        <hr class="hr mob-only" />
        <div class="tt-inner">
          <TopTournaments {topTournaments} {locale} />
        </div>
        <button class="tt-view-more sf-500" on:click={() => goto(`/tournaments`)}>All Tournaments</button>
      </div>
    </div>
  {/if}
  {#if pageInfo?.content}
    <div class="page-text full-width">
      <div class="page-content text-inner generic-content">{@html pageInfo?.content || ""}</div>
    </div>
  {/if}
</div>

<style lang="scss">
  // Home Page
  @use "@styles/breakpoint-mixins" as *;
  $bannerHeight: 431px;

  .home-page {
    background: #fff;
    @include desktop {
      background: #f8f8f8;
    }
    h2 {
      text-align: center;
      margin-bottom: 0.94em;
      font-size: 1.25em;
      @include desktop {
        font-size: 2.5em;
      }
    }
  }

  .hero-bg {
    background: #000;
    padding: 2em;
    justify-items: center;
    @include tablet {
      margin-bottom: 4.25em;
    }

    @media (min-width: 1336px) {
      background: linear-gradient(90deg, #121317 50%, #121317 50%, #00a88f 100%);
      padding: 0;
      height: $bannerHeight;
      justify-items: unset;
      position: relative;
      margin-bottom: 6.25em;
    }

    .slider-container {
      display: grid;
      grid-template-columns: 1fr;
      width: 100%;
      @media (min-width: 1336px) {
        grid-template-columns: 540px auto;
        gap: 30px;
      }

      .left-top {
        text-align: center;
        position: relative;
        @media (min-width: 1336px) {
          text-align: left;
          align-items: center;
        }
        .one-bg {
          position: absolute;
          top: 20%;
          right: 20%;
          left: 10%;
          bottom: 15%;
          background: url("./_home-page/background-one.svg");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
        }
        h2 {
          align-self: end;
          color: #fff;
          font-size: 1.4375em;
          line-height: 1.875em;
          margin-bottom: 1.25em;
          @media (min-width: 1336px) {
            text-align: left;
            font-size: 2.1875em;
            font-weight: 700;
          }

          &.search-header {
            color: #fff;
            text-align: center;
            font-family: Nunito;
            font-size: 20px;
            font-style: normal;
            font-weight: 500;
            line-height: 1em; /* 20px */
            @media (min-width: 1336px) {
              text-align: left;
              font-size: 35px;
              font-weight: 700;
              line-height: 30px; /* 85.714% */
              margin-bottom: 20px;
            }
          }
        }

        p.search-header-text {
          display: none;
          margin: 0;
          @media (min-width: 1336px) {
            display: inline-block;
            width: 31em;
            color: #fff;
            font-size: 1.125em;
            line-height: 1.25em;
            margin-bottom: 2.5em;
          }
        }
      }

      .home-slider {
        display: none;
        @media (min-width: 1336px) {
          display: grid;
          height: $bannerHeight;
        }
      }
    }
  }

  .popular-tickets {
    padding-top: 2.5em;
    @include desktop {
      padding: 0 0 6.2em 0;
      h2 {
        text-align: center;
        font-size: 40px;
        line-height: 1em;
        margin-bottom: 1.25em;
      }
    }
  }

  .upcoming-bg {
    background: #fff;
    .upcoming-games {
      padding-top: 40px;

      @include desktop {
        padding: 0;
        margin-top: 7.56em;
        margin-bottom: 7em;
        grid-template-columns: auto 32%;
      }

      .upcoming-games-inner {
        @include desktop {
          grid-template-columns: auto 32%;
          align-items: start;
        }
      }
    }

    .upcoming-games-right {
      display: none;
      @include desktop {
        display: flex;
        flex-direction: column;
        height: 100%;
        align-items: center;
      }
    }
  }

  .trustpilot-mobile {
    display: flex;
    height: 6.875rem;
    border-radius: 0.3125rem;
    background: #f8f8f8;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.12em;
    @include desktop {
      display: none;
    }
  }

  .top-tt {
    padding-top: 3em;

    .top-tt-container {
      background: #f8f8f8;
      padding: 1em 0;
      margin-bottom: 1.13em;
      border-radius: 0.3125em;
      grid-template-columns: 1fr;
      @include desktop {
        padding: 6.5em 0;
      }

      .hr {
        border-bottom: 1px solid #aeb2e6;
        width: 90%;
        margin: auto;
        margin-bottom: 1em;
      }

      .tt-inner {
        margin-bottom: 1.25em;
        @include desktop {
          margin-bottom: 3.12em;
        }
      }
      .tt-view-more {
        color: #fff;
        text-align: center;
        font-family: Nunito;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 30px; /* 187.5% */
        height: 44px;
        flex-shrink: 0;
        padding: 0;
        @include desktop {
          margin: auto;
          width: 17.43em;
        }
      }
    }
    .tournaments-bg-w {
      @include desktop {
        background: #fff;
      }
    }
  }

  .tournaments-bg {
    background: #fff;
  }

  .page-text {
    background: #fff;
    @include desktop {
      background: #f8f8f8;
    }
    .text-inner {
      padding: 1.25em;
      @include desktop {
        padding: 5.65em 0;
        column-count: 2;
        column-gap: 3em;
      }
    }
    :global(.text-inner ul) {
      margin-left: 1.3em;
    }
  }
</style>
